module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-navbar', {
    attrs: {
      "toggleable": "",
      "toggle-breakpoint": "xl",
      "fixed": "top",
      "type": "dark"
    },
    nativeOn: {
      "click": function($event) {
        _vm.onMenuClick($event)
      }
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/logo.png"),
      "width": "150",
      "alt": ""
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "tel",
    attrs: {
      "href": "tel:+78129161500"
    },
    on: {
      "click": _vm.call
    }
  }, [_vm._v("+7 (812) 916-15-00")])]), _vm._v(" "), _c('b-nav-toggle', {
    ref: "navToggler",
    attrs: {
      "target": "nav_collapse"
    }
  }), _vm._v(" "), _c('b-collapse', {
    ref: "collapseNav",
    attrs: {
      "is-nav": "",
      "id": "nav_collapse"
    }
  }, [_c('b-nav', {
    staticClass: "ml-auto",
    attrs: {
      "is-nav-bar": ""
    }
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'CoursesEntry'
      }
    }
  }, [_vm._v("Начальный уровень")])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'OnlineEnrollment'
      }
    }
  }, [_vm._v("Запись on-line")])], 1), _vm._v(" "), _c('b-nav-item-dropdown', {
    attrs: {
      "text": "Подробнее",
      "right": ""
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'AboutCourses'
      }
    }
  }, [_vm._v("О курсах")]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'AboutLectors'
      }
    }
  }, [_vm._v("О лекторах")]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'Contacts'
      }
    }
  }, [_vm._v("Контакты")])], 1), _vm._v(" "), (_vm.isDevMode) ? _c('li', {
    staticClass: "vertical-delimiter"
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.isDevMode && !_vm.isAuth) ? _c('li', {
    staticClass: "auth-btn nav-item",
    on: {
      "!click": function($event) {
        _vm.clicked($event)
      }
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    class: {
      'disabled wait': !this.$store.state.auth.userChecked
    },
    attrs: {
      "to": "/login",
      "exact": ""
    }
  }, [_vm._v("\n              Войти\n            ")])], 1) : _vm._e(), _vm._v(" "), (_vm.isAuth) ? _c('b-nav-item-dropdown', {
    staticClass: "auth-btn",
    attrs: {
      "text": "Профиль",
      "right": ""
    }
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'Profile'
      }
    }
  }, [_vm._v("Личный кабинет")]), _vm._v(" "), _c('a', {
    staticClass: "nav-link",
    class: {
      'disabled wait': _vm.inProgress
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.logout()
      }
    }
  }, [_vm._v("Выход")])], 1) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14e6d522"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navbar.vue
// module id = 220
// module chunks = 1